import React from "react"
import styled from "styled-components"
import media from "cssMix/index"

const StyledFooter = styled.footer`
  color: ${({ theme }) => theme.colors["4"]};
  font-size: 15px;
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
  ${media.tablet`
    font-size:13px;
    `}
`
const Footer = () => {
  const year = new Date().getFullYear()
  return <StyledFooter>© {year} CQ9 GAMING</StyledFooter>
}

export default Footer
